export const COLLAPSED = Object.freeze({ services: false, categories: false, statuses: false });
export const FILTER_RELOAD = "filters";

export function toggleSection(sections, section) {
  return { ...sections, [section]: !sections[section] };
}

export function sectionsAfterChange(sections, name) {
  return name === "service" ? { ...sections, services: false } : sections;
}

export function menuMaxHeight({ top, viewport, margin = 16, min = 240 }) {
  return Math.max(min, Math.floor(viewport - top - margin));
}

export function claimReopen(pending, reason) {
  if (!pending || reason !== FILTER_RELOAD) return { open: false, focusKey: null, sections: COLLAPSED, listScroll: 0 };
  return { open: true, focusKey: pending.focusKey || null, sections: pending.sections || COLLAPSED, listScroll: pending.listScroll || 0 };
}

export function scrollToShow(item, view) {
  if (item.top < view.top) return item.top - view.top;
  if (item.bottom > view.bottom) return Math.min(item.bottom - view.bottom, item.top - view.top);
  return 0;
}

export function serviceSummary(value, label) {
  return { dotClass: `tg-filters-dot tg-filters-dot-${value}`, label: String(label).trim() };
}

export function statusSummary(rows) {
  const indexes = rows.map((row, index) => (row.checked ? index : null)).filter((index) => index !== null);
  if (indexes.length === rows.length) return { label: "All statuses", active: false, shown: [] };
  if (indexes.length === 0) return { label: "No statuses", active: true, shown: [] };
  return { label: indexes.map((index) => String(rows[index].label).trim()).join(", "), active: true, shown: indexes };
}

export function categorySummary(rows) {
  const checked = rows.filter((row) => row.checked).map((row) => String(row.label).trim());
  if (checked.length === 0) return { label: "All categories", active: false };
  return { label: checked.join(", "), active: true };
}

export function checkedAfterReset(detail, name, value) {
  switch (name) {
    case "lanes":
    case "service":
      return value === detail[name];
    case "blocks":
    case "schedules":
      return detail[name] === "show";
    case "scheduled":
      return detail.scheduled === "only";
    case "category":
      return detail.categories.includes(value);
    case "status":
      return !detail.hiddenStatuses.includes(value);
    default:
      return null;
  }
}

export function facilitySelection(options, value) {
  const picked = options.find((option) => option.value === value);
  if (!picked) return null;
  return { selected: options.map((option) => option === picked), label: String(picked.label).trim() };
}

export function showAllFocusKey(open, firstRowKey) {
  return open && firstRowKey ? firstRowKey : "statuses-summary";
}
